import { useColorMode } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import logos from '../images/logos';
import { IBestPrice, INetProfit } from '../types';

type logoKeyType = keyof (typeof logos)['light'];

export default function useGetBestPriceData(
    token: string,
    internalId: string,
    timePlacedStart?: string
) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>();
    const colorMode = useColorMode();
    const logosWithTheme = logos[colorMode.colorMode];

    const [result, setResult] = useState<
        [IBestPrice |  null, INetProfit[]] | null
    >(null);

    useEffect(
        function () {
            const controller = new AbortController();
            const signal = controller.signal;

            (async function () {
                setLoading(true);
                try {
                    let bestPriceUrl = `${process.env.REACT_APP_API_BASE || ''}/v1/bettors/${internalId}?metadata=true&bestPriceEstimate=true`
                    let netProfitUrl = `${process.env.REACT_APP_API_BASE || ''}/v1/bettors/${internalId}/bettorAccounts?metadata=true&bestPriceEstimate=true&access=true`
                    if (timePlacedStart) {
                        bestPriceUrl += `&timePlacedStart=${timePlacedStart}`
                        netProfitUrl += `&timePlacedStart=${timePlacedStart}`
                    }
                    const bestPricePromise = fetch(bestPriceUrl,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: token,
                            },
                        }
                    );

                    const netProfitPromise = fetch(netProfitUrl,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: token,
                            },
                            signal,
                        }
                    );

                    const [bestPriceJSONPromise, netProfitJSONPromise] =
                        await Promise.all([bestPricePromise, netProfitPromise]);


                    if ((netProfitJSONPromise.status != 200) || (bestPriceJSONPromise.status != 200)){
                        setResult([null,[]])
                    } else {
                        const [bestPriceJSON, netProfitJSON] = await Promise.all([
                            bestPriceJSONPromise.json(),
                            netProfitJSONPromise.json(),
                        ]);

                        const bestPriceData = bestPriceJSON.metadata;
                        setResult([bestPriceData, netProfitJSON]);
                    }
                } catch (error) {
                    setError(error as string);
                } finally {
                    setLoading(false);
                }
            })();

            return () => controller.abort();
        },
        [timePlacedStart]
    );

    return { loading, result, error };
}
